"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Hooks = __importStar(require("@apollo/react-hooks"));
var ApolloDefender_1 = require("../ApolloDefender");
function useSubscription(query, variables, options) {
    var result = Hooks.useSubscription(query, __assign({ variables: variables }, options));
    ApolloDefender_1.useApolloDefenderReporter(result.error, query, variables);
    return result;
}
exports.useSubscription = useSubscription;
//# sourceMappingURL=useSubscription.js.map